/**
 * Returns an object containing key-value pairs from the document cookie
 * where the key matches specified patterns used for purchase attribution.
 * @returns {Object.<string, string>} An object containing the filtered key-value pairs.
 */
export const getLinkAttribution = () => {
    const cookies = document.cookie.split(';');
    const attributionCookies = {};

    const patterns = [
        '^utm_',    // ^ means starts with
        '^trk_',
        '^fbclid',
        '^_fbp$',   // $ means ends with
        '^_fbc$',
        '^aff_trk_[1-4]',
        '^campaign$',
    ];

    cookies.forEach(cookie => {
        const [key, value] = cookie.trim().split('=');
        const trimmedKey = key.trim();
        patterns.forEach(pattern => {
            if (trimmedKey.match(new RegExp(pattern))) {
                attributionCookies[trimmedKey] = value;
            }
        });
    });

    if (window.__barkTracking) {
        try {
            const newData = window.__barkTracking.getParams();
            window.DD_RUM?.addAction('bark_attribution_read_compare', {
                read_point: 'getLinkAttribution',
                old_value: attributionCookies,
                new_value: newData,
                match: JSON.stringify(attributionCookies) === JSON.stringify(newData),
                url: window.location.href,
            });
        } catch (e) { /* never break attribution reads */ }
    }

    return attributionCookies;
};
